/** Session cache — survives row unmount when filters/sorts reshuffle the table. */
const loadedPortraitUrls = new Set<string>()

export function isPortraitUrlCached(url: string): boolean {
  return loadedPortraitUrls.has(url)
}

export function markPortraitUrlLoaded(url: string): void {
  loadedPortraitUrls.add(url)
}

export function clearPortraitUrlCache(url: string): void {
  loadedPortraitUrls.delete(url)
}
